import UpgradeItem from "./upgrade-item.component";

export default UpgradeItem;
